module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (2).0d7f3ce3.svg";